export default __webpack_public_path__ + "static/media/linkedin_i.75e66d06.svg";